import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function RenewalPayment() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    cardNumber: '',
    expiryDate: '',
    cvv: '',
    name: '',
    saveCard: false,
  });

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    // TODO: Implement actual payment processing
    navigate('/renewal/review');
  };

  return (
    <div className="max-w-md mx-auto">
      <h1 className="text-2xl font-bold text-white mb-6">Payment Details</h1>

      <div className="bg-white/5 rounded-lg p-8">
        <div className="mb-6">
          <h2 className="text-lg font-semibold text-white mb-2">Order Summary</h2>
          <div className="bg-white/5 rounded p-4">
            <div className="flex justify-between text-gray-300">
              <span>Full Membership Renewal</span>
              <span>£50.00</span>
            </div>
            <div className="border-t border-gray-600 my-2"></div>
            <div className="flex justify-between font-semibold text-white">
              <span>Total</span>
              <span>£50.00</span>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="card-number" className="block text-gray-300 mb-2">
              Card Number
            </label>
            <input
              id="card-number"
              type="text"
              name="cardNumber"
              value={formData.cardNumber}
              onChange={handleChange}
              className="w-full p-2 rounded bg-hdlcc-gray border border-hdlcc-gray focus:border-hdlcc-lightBlue focus:outline-none"
              required
              placeholder="1234 5678 9012 3456"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="expiry-date" className="block text-gray-300 mb-2">
                Expiry Date
              </label>
              <input
                id="expiry-date"
                type="text"
                name="expiryDate"
                value={formData.expiryDate}
                onChange={handleChange}
                className="w-full p-2 rounded bg-hdlcc-gray border border-hdlcc-gray focus:border-hdlcc-lightBlue focus:outline-none"
                required
                placeholder="MM/YY"
              />
            </div>
            <div>
              <label htmlFor="cvv" className="block text-gray-300 mb-2">
                CVV
              </label>
              <input
                id="cvv"
                type="text"
                name="cvv"
                value={formData.cvv}
                onChange={handleChange}
                className="w-full p-2 rounded bg-hdlcc-gray border border-hdlcc-gray focus:border-hdlcc-lightBlue focus:outline-none"
                required
                placeholder="123"
              />
            </div>
          </div>

          <div>
            <label htmlFor="card-name" className="block text-gray-300 mb-2">
              Name on Card
            </label>
            <input
              id="card-name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-2 rounded bg-hdlcc-gray border border-hdlcc-gray focus:border-hdlcc-lightBlue focus:outline-none"
              required
              placeholder="John Smith"
            />
          </div>

          <div className="flex items-center">
            <input
              id="save-card"
              type="checkbox"
              name="saveCard"
              checked={formData.saveCard}
              onChange={handleChange}
              className="rounded border-gray-300 text-hdlcc-lightBlue focus:ring-hdlcc-lightBlue"
            />
            <label htmlFor="save-card" className="ml-2 text-gray-300">
              Save card for future payments
            </label>
          </div>

          <div className="flex justify-between mt-8">
            <button
              type="button"
              onClick={() => navigate('/renewal/type')}
              className="text-hdlcc-lightBlue hover:text-hdlcc-blue"
            >
              ← Back
            </button>
            <button
              type="submit"
              className="bg-hdlcc-lightBlue text-white px-8 py-3 rounded-lg hover:bg-hdlcc-blue transition-colors"
            >
              Complete Payment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RenewalPayment;
